import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "bulb_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 9a7.997 7.997 0 0 1-4 6.93V18h-3v-6h2v-2H9v2h2v6H8v-2.07A8 8 0 1 1 20 9ZM14.5 22a1.5 1.5 0 0 0 1.5-1.5V20H8v.5A1.5 1.5 0 0 0 9.5 22h5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }